import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const MuiSelectWithTextInputWrapper = styled.div`
  margin-top: 5px;

  ${responsive.MOBILE`
      margin-top: 0;
    `}
  .MuiInputBase-adornedStart {
    padding-left: 0px;
  }

  .mui-label-select {
    line-height: 18px;
    color: ${COLORS.cirrus_black10};
    margin-bottom: 3px;
  }

  .dropdown-prefix {
    display: flex;
    width: 163px;
    margin-top: 0px;
    ${responsive.MOBILE`
     width: 137px;
    `}

    .mui-select {
      border-radius: 0px;

      &::after {
        padding-left: 20px;
        content: "|";
        color: ${COLORS.cirrus_black4};
      }
      .MuiSelect-select {
        ${responsive.MOBILE`
            display: block;
            width: 123px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right:10px;
        `}
      }
    }

    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      //border: 1px solid blue;
    }
  }

  .MuiInputAdornment-root {
    margin-right: 0px;
  }

  .line {
    color: ${COLORS.cirrus_black4};
  }
`;
